import React from "react";
import ReactDOM from "react-dom";
import { Section, Box, Heading, Paragraph, Image, Video, Label } from "grommet";

import angrypi from "./angrypi.jpg";
import render from "./render.png";

const AngryPi = props => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        AngryPi
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box
        direction="column"
        basis="2/3"
        margin="small"
        textAlign="left"
        align="left"
      >
        <Image src={angrypi} size="large" />
        <Paragraph>
          AngryPi is the worlds angriest raspberry pi. How did he get this way?
          Some think he just woke up one day like this. AngryPi is a raspberry
          pi case I modelled in blender and then 3D printed. It houses an
          overclocked gen 1 raspberry pi. I created AngryPi at the same time I
          was working with some frustrating IBM software. I think this
          frustration may have come out in the design of AngryPi!
        </Paragraph>
        <Paragraph>I've used AngryPi for a variety of tasks:</Paragraph>
        <ul>
          <li>NAS exposing windows shared via samba</li>
          <li>Automated backups</li>
          <li>Home DNS and DHCP server</li>
          <li>Games Console with a huge variety of SNES games</li>
        </ul>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          The head was the most difficult piece to model, and the most fun. I
          wanted to create a face with as much rage as possible. I was inspired
          by 'Doom' for a lot of the design.
        </Paragraph>
        <Image src={render} size="large" />
        <Label size="small">Render inside Blender</Label>
        <Paragraph>
          It took about 24 hours in total to print on my UP 2 printer. The upper
          and lower casing were printed separately and then joined once the
          raspberry pi was inside. Each of the legs were printed separately and
          glued on.
        </Paragraph>
      </Box>
    </Box>
  </Section>
);

export default AngryPi;



// WEBPACK FOOTER //
// ./src/components/projects/angrypi/angrypi.js